(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    if (!window.NuraleaColorSwatches) {
    window.NuraleaColorSwatches = true;

    const enhanceColorFieldset = (fieldset) => {
      const firstInput = fieldset.querySelector('input[data-option-name]');
      const optionName = firstInput?.dataset.optionName?.trim();

      if (!optionName || !fieldset.classList.contains('variant-option--swatches')) return;

      const legend = fieldset.querySelector('legend');
      const checkedInput = fieldset.querySelector('input:checked');

      if (!legend || !checkedInput) return;

      let selectedColor = legend.querySelector('[data-nuralea-selected-color]');

      if (!selectedColor) {
        legend.textContent = `${optionName}: `;
        selectedColor = document.createElement('span');
        selectedColor.dataset.nuraleaSelectedColor = '';
        legend.append(selectedColor);
      }

      if (selectedColor.textContent !== checkedInput.value) {
        selectedColor.textContent = checkedInput.value;
      }
    };

    const initializeColorSwatches = (root = document) => {
      root.querySelectorAll('variant-picker fieldset.variant-option--buttons').forEach(enhanceColorFieldset);
    };

    initializeColorSwatches();

    document.addEventListener('change', (event) => {
      const fieldset = event.target.closest?.('variant-picker fieldset.variant-option--buttons');
      if (fieldset) {
        enhanceColorFieldset(fieldset);
        requestAnimationFrame(() => initializeColorSwatches());
      }
    });

    document.addEventListener('shopify:section:load', (event) => initializeColorSwatches(event.target));

    new MutationObserver((records) => {
      const fieldsets = new Set();

      records.forEach((record) => {
        const targetElement =
          record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        const targetFieldset = targetElement?.closest?.('variant-picker fieldset.variant-option--buttons');

        if (targetFieldset) fieldsets.add(targetFieldset);

        record.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          if (node.matches?.('variant-picker fieldset.variant-option--buttons')) {
            fieldsets.add(node);
          }

          node.querySelectorAll?.('variant-picker fieldset.variant-option--buttons').forEach((fieldset) => {
            fieldsets.add(fieldset);
          });
        });
      });

      fieldsets.forEach(enhanceColorFieldset);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

})();
